module.exports = __webpack_public_path__ + "img/banner_zhnm.5012577f.png";